/* FIXED, CLEANED & FULLY WORKING VERSION */

import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, Checkbox, message } from "antd";
import { EnvironmentOutlined, SearchOutlined } from "@ant-design/icons";
import DeliveryAddressServ from "../service/DeliveryAddressesServ";
import GlobalMap from "../util/GlobalMap";
import "../css/ChangeLocationContent.css";

const AddDeliveryAddress = ({
  open,
  onClose,
  addressDetails,
  isEditing,
  refreshAddress,
}) => {
  const [form] = Form.useForm();
  const [address, setAddress] = useState("");

  /* ------- Prefill when editing ------- */
  useEffect(() => {
    if (open) {
      if (isEditing && addressDetails) {
        form.setFieldsValue(addressDetails);
        setAddress(addressDetails.address || "");
      } else {
        form.resetFields();
        setAddress("");
      }
    }
  }, [open, isEditing, addressDetails, form]);

  const latVal = Form.useWatch('latitude', form);
  const lngVal = Form.useWatch('longitude', form);

  /* ------- Auto-Fill Fields ------- */
  const fillAddressFields = (data) => {
    form.setFieldsValue({
      addressLine: data.address || "",
      city: data.city || data.district || "",
      pincode: data.zipCode || "",
      latitude: data.latitude,
      longitude: data.longitude,
    });
    setAddress(data.address || "");
  };

  /* ------- Submit Form ------- */
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (isEditing) {
        await DeliveryAddressServ.update(addressDetails._id, values);
        message.success("Address updated successfully!");
      } else {
        await DeliveryAddressServ.create(values);
        message.success("Address added successfully!");
      }

      refreshAddress(true);
      onClose();
    } catch (error) {
      message.error("Failed to save address");
      console.error(error);
    }
  };

  return (
    <Modal
      title={
        <>
          <EnvironmentOutlined />{" "}
          {isEditing ? "Edit Delivery Address" : "Add Delivery Address"}
        </>
      }
      open={open}
      onCancel={onClose}
      width={700}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {isEditing ? "Update" : "Save"}
        </Button>,
      ]}
    >
      {/* GlobalMap Handles Search, Detect & Map Interaction */}
      <GlobalMap
        height="300px"
        address={address}
        onLocationSelect={fillAddressFields}
        markerPosition={
          latVal && lngVal ? { lat: parseFloat(latVal), lng: parseFloat(lngVal) } : null
        }
      />

      {/* Address Form */}
      <Form form={form} layout="vertical" className="pcu-margin-top-15">
        <Form.Item name="name" label="Address Name (e.g. Warehouse 1)" rules={[{ required: true }]}>
          <Input placeholder="Enter a name for this location" />
        </Form.Item>

        <Form.Item name="addressLine" label="Full Address" rules={[{ required: true }]}>
          <Input.TextArea rows={2} placeholder="Street, Building, etc." />
        </Form.Item>

        <Form.Item name="city" label="City" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="pincode" label="Pincode" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="contactNumber" label="Contact Number" rules={[{ required: true, message: 'Please enter a contact number' }]}>
          <Input placeholder="Phone number for pickup coordination" />
        </Form.Item>

        <div className="pcu-display-none">
          <Form.Item name="latitude"><Input /></Form.Item>
          <Form.Item name="longitude"><Input /></Form.Item>
        </div>

        <Form.Item name="isDefault" valuePropName="checked">
          <Checkbox>Set as default pickup address</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDeliveryAddress;

